import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const db = getFirestore(app);

// Use an explicit environment variable to control emulator connection
// This is an industry best practice for switching between environments
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  console.log("Connecting to Firebase Emulators...");
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFirestoreEmulator(db, 'localhost', 8080);
} else {
  console.log("Connecting to live Firebase services...");
}

const getProjects = httpsCallable(functions, 'get_projects');
const createProject = httpsCallable(functions, 'create_project');
const updateProjectName = httpsCallable(functions, 'update_project_name');
const deleteProject = httpsCallable(functions, 'delete_project');
const createCheckoutSession = httpsCallable(functions, 'create_checkout_session');
const createSubscriptionCheckout = httpsCallable(functions, 'create_subscription_checkout');
const createPortalSession = httpsCallable(functions, 'create_portal_session');
const listCreditPacks = httpsCallable(functions, 'list_credit_packs');
const updateUserProfile = httpsCallable(functions, 'update_user_profile');
const deleteUserAccount = httpsCallable(functions, 'delete_user_account');
const registerPushToken = httpsCallable(functions, 'register_push_token');
const removePushToken = httpsCallable(functions, 'remove_push_token');
const sendTestPush = httpsCallable(functions, 'send_test_push');
const submitFeedback = httpsCallable(functions, 'submit_feedback');

// Exported so the notification service can register a service worker
// with the same Firebase config (per-environment) used by the main app.
export { firebaseConfig };

export { auth, storage, functions, db, getProjects, createProject, updateProjectName, deleteProject, createCheckoutSession, createSubscriptionCheckout, createPortalSession, listCreditPacks, updateUserProfile, deleteUserAccount, registerPushToken, removePushToken, sendTestPush, submitFeedback };
